import type Swiper from 'swiper';
import './../css/nunito-font.css';
import './modules/video-player';

document.addEventListener('click', (e) => {
  const trigger = e.target as HTMLElement;

  if (!trigger.classList.contains('accordion-trigger')) return;

  e.preventDefault();

  const item = trigger.closest('.accordion-item');
  const icon = trigger.querySelector('svg');
  const content = item?.querySelector('.accordion-content') as HTMLElement;

  if (!content) return;

  const isOpen = content.classList.contains('open');

  if (isOpen) {
    content.classList.remove('open');
    content.style.maxHeight = '0';
    if (icon) {
      icon.style.transform = 'rotate(0deg)';
    }
  } else {
    content.classList.add('open');
    content.style.maxHeight = content.scrollHeight + 'px';
    if (icon) {
      icon.style.transform = 'rotate(180deg)';
    }
  }
});

document.addEventListener('change', async (e) => {
  const target = e.target as HTMLElement;
  if (!(target instanceof HTMLSelectElement)) return;
  if (target.id !== 'mark') return;

  const modelSelect = document.getElementById('model') as
    | HTMLSelectElement
    | HTMLInputElement
    | null;

  if (!modelSelect) return;

  const make = target.value;

  const isSelect = modelSelect instanceof HTMLSelectElement;
  const isInput = modelSelect instanceof HTMLInputElement;

  let placeholder: HTMLOptionElement | null = null;
  let datalist: HTMLDataListElement | null = null;

  if (isSelect) {
    placeholder = modelSelect.options[0] ?? null;
  }

  if (isInput) {
    datalist = document.getElementById(
      `list-${modelSelect.id}`,
    ) as HTMLDataListElement | null;

    if (!datalist) {
      datalist = document.createElement('datalist');
      datalist.id = `list-${modelSelect.id}`;
      document.body.appendChild(datalist);
    }

    modelSelect.setAttribute('list', datalist.id);
  }

  const resetModelField = () => {
    if (isSelect) {
      modelSelect.innerHTML = '';
      if (placeholder) {
        modelSelect.appendChild(placeholder);
      }
    }

    if (isInput && datalist) {
      modelSelect.value = '';
      datalist.innerHTML = '';
    }
  };

  if (!make) {
    resetModelField();
    return;
  }

  try {
    if (modelSelect.parentElement) {
      modelSelect.parentElement.classList.add('is-loading');
    }

    const headers = new Headers();
    headers.append('X-WP-Nonce', window.theme.api.nonce);

    modelSelect.disabled = true;

    const response = await fetch(
      `/wp-json/w8/v2/models?make=${encodeURIComponent(make)}`,
      { headers },
    );

    if (!response.ok) {
      throw new Error('Failed to load models');
    }

    const models: { id: number | null; name: string | null }[] =
      await response.json();

    resetModelField();

    models.forEach((model) => {
      if (!model.id || !model.name) return;

      if (isSelect) {
        const option = document.createElement('option');
        option.value = model.id.toString();
        option.textContent = model.name;
        modelSelect.appendChild(option);
      }

      if (isInput && datalist) {
        const option = document.createElement('option');
        option.value = model.name;
        option.dataset.id = model.id.toString();
        datalist.appendChild(option);
      }
    });

    modelSelect.disabled = false;
  } catch (error) {
    resetModelField();
    modelSelect.disabled = true;
    console.error(error);
  } finally {
    if (modelSelect.parentElement) {
      modelSelect.parentElement.classList.remove('is-loading');
    }
  }
});

document.addEventListener('click', (event) => {
  const target = event.target as HTMLElement;
  if (!target) return;

  const button = target.closest<HTMLElement>('.line-clamp-collapse-btn');
  if (!button) return;

  event.preventDefault();

  const parent = button.closest<HTMLElement>('.swiper-slide');
  if (!parent) return;

  const textElement = parent.querySelector<HTMLElement>(
    '[data-collapse-element]',
  );
  if (!textElement) return;

  textElement.classList.toggle('line-clamp-5');

  const expandSpan = button.querySelector<HTMLElement>('span:nth-child(1)');
  const collapseSpan = button.querySelector<HTMLElement>('span:nth-child(2)');

  expandSpan?.classList.toggle('hidden');
  collapseSpan?.classList.toggle('hidden');

  const slide = button.closest<HTMLElement>('.swiper-slide');
  if (!slide || window.screen.width >= 768) return;

  // ✅ знайти найближчий Swiper і оновити висоту
  const swiperEl = slide.closest<HTMLElement>('.swiper');
  if (swiperEl && 'swiper' in swiperEl) {
    const swiper = swiperEl.swiper as Swiper;

    // Дай браузеру застосувати класи перед вимірюванням висоти
    requestAnimationFrame(() => {
      swiper.updateAutoHeight(300); // 300ms transition duration (optional)
      swiper.update();
    });
  }
});
